import { requestBuilder } from '../../../http/RequestBuilder';
import type { Card, IssueCardBody } from '../../types/Card';

// TODO make a real return type here
const useIssueCard = requestBuilder.mutation<Card, IssueCardBody>({
    endpoint: '/api/card',
    method: 'POST',
});

export default useIssueCard;
